import React from 'react';
import { Icon } from '@progress/kendo-react-common';
import { ITicket } from '../../../../types/Ticket/ITicket';
import ReactTimeAgo from 'react-timeago'

const AutoStatusBanner: React.FC<{ ticket: ITicket }> = ({ ticket }) => {

    if (ticket?.Auto_Status_Text === null) return null;

    return (
        <div className='auto-status-banner' >
            <Icon name="calendar" style={{ marginRight: '8px' }} />
            {ticket?.Auto_Status_Text}&nbsp;
            <u><ReactTimeAgo title={new Date(ticket?.Auto_Status_Date + 'Z').toDateString() + ' ' + new Date(ticket?.Auto_Status_Date + 'Z').toLocaleTimeString()} date={new Date(ticket?.Auto_Status_Date + 'Z')} ></ReactTimeAgo></u>
        </div>
    );
};

export default AutoStatusBanner; 